import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { EndpointItem, RouteItem } from '@wajeez-web/core/types';
import { NavigationState } from './types';

export const name = 'navigation';

const initialState: NavigationState = {
  routes: [],
  endpoints: [],
};

export const slice = createSlice({
  name: name,
  initialState,
  reducers: {
    reset: (state) => {
      return initialState;
    },
    addRoutes: (state, action: PayloadAction<RouteItem[]>) => {
      return {
        ...state,
        routes: [...state.routes, ...action.payload],
      };
    },
    updateRoutes: (state, action: PayloadAction<RouteItem[]>) => {
      for (let i = 0; i < action.payload.length; i++) {
        const route = action.payload[i];
        const index = state.routes.findIndex((r) => r.name === route.name);
        if (index > -1) {
          state.routes[index] = route;
        } else {
          state.routes.push(route);
        }
      }
      return state;
      // return {
      //   ...state,
      //   routes: action.payload,
      // };
    },
    updateRoute: (state, action: PayloadAction<RouteItem>) => {
      const index = state.routes.findIndex(
        (r) => r.name === action.payload.name
      );
      if (index > -1) {
        state.routes[index] = action.payload;
      } else {
        state.routes.push(action.payload);
      }
      return state;
    },

    addEndpoints: (state, action: PayloadAction<EndpointItem[]>) => {
      return {
        ...state,
        endpoints: [...state.endpoints, ...action.payload],
      };
    },
    updateEndpoints: (state, action: PayloadAction<EndpointItem[]>) => {
      for (let i = 0; i < action.payload.length; i++) {
        const endpoint = action.payload[i];
        const index = state.endpoints.findIndex(
          (e) => e.endpoint === endpoint.endpoint
        );
        if (index > -1) {
          state.endpoints[index] = endpoint;
        } else {
          state.endpoints.push(endpoint);
        }
      }
      return state;
      // return {
      //   ...state,
      //   endpoints: action.payload,
      // };
    },
    updateEndpoint: (state, action: PayloadAction<EndpointItem>) => {
      const index = state.endpoints.findIndex(
        (r) => r.endpoint === action.payload.endpoint
      );
      if (index > -1) {
        state.endpoints[index] = action.payload;
      } else {
        state.endpoints.push(action.payload);
      }
      return state;
    },
  },
});

export const actions = slice.actions;

export default slice.reducer;
